import { action } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { AppManager, Input } from 'core/index';

import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { redirectToContent, raiseUserError } from 'apps/utils';
import { IssueApp } from 'apps/issueTracker/apps/issueApp';
import { LabelsApp } from 'apps/issueTracker/apps/labelApp';

import { IssueMutation } from 'apps/issueTracker/gql';
import { analytics } from 'core/analytics';
import { TagsApp } from 'apps/tag/app';

export class IssueFormAppManager extends AppManager {
  static registryName = 'IssueFormAppManager';
  constructor(parent, init = {}) {
    super(parent, init);

    this.issueFormApp = new IssueApp(this, {
      labels: new LabelsApp(),
      tags: new TagsApp(),
    });
    this.issueFormApp.createForm();
    this.issueInput = new Input({
      projectId: () => init.issueTracker.id,
      title: () => this.issueFormApp.title,
      description: () => this.issueFormApp.description,
      labels: () =>
        this.issueFormApp.labels.map(label => ({
          labelId: label.id,
          deleted: label.deleted,
        })),
      tags: () => this.issueFormApp.tags.map(({ name }) => ({ name })),
    });
  }

  @action onSubmitSysErr = () => {
    this.issueFormApp?.form.SetPosting(false);
    clientStore.SetPosting(false);
    Alert.error(
      i18next.t('Hmm... We failed to submit your Issue. Please try again.'),
    );
  };

  @action onSubmitUserErr = error => {
    this.issueFormApp?.form.SetPosting(false);
    clientStore.SetPosting(false);
    raiseUserError(error, 'submit', 'Issue');
  };

  @action onSubmitSuccess = result => {
    this.issueFormApp?.form.SetPosting(false);
    this.issueFormApp?.form.clearDraft();
    clientStore.SetPosting(false);
    modalStore.ClearComponent();

    this.issueTracker.manager.NewVariables();
    redirectToContent(result, 'issue', {
      slug: result.inSpace.content.slug,
      issueSlug: result.slug,
    });
    const { number } = result;
    Alert.success(
      i18next.t('Issue #{{number}} opened successfully!', { number }),
    );
  };

  @action Submit = () => {
    const { issueFormApp } = this;
    if (!issueFormApp) return;
    if (issueFormApp.form.isValid) {
      issueFormApp.form.SetPosting(true);
      clientStore.SetPosting(true);
      analytics.sendEvent('submitted-post-issue');
      this.mutations.push(
        IssueMutation.New(this.issueInput, {
          onSysErr: this.onSubmitSysErr,
          onUserErr: this.onSubmitUserErr,
          onSuccess: this.onSubmitSuccess,
        }),
      );
    } else {
      issueFormApp.form.alert();
    }
  };
}
